module.exports = __webpack_public_path__ + "img/head.123181fc.jpg";